import { useSelector } from 'react-redux'

import { displayTaxesSelector } from '@/selectors'

import TaxListItem from './TaxListItem'
import TaxListItems from './TaxListItems'

const Taxes = () => {
  const details = useSelector(state => state.taxes.details)
  const label = useSelector(state => state.taxes.label)
  const displayTaxes = useSelector(displayTaxesSelector)
  const isCalculated = useSelector(state => state.taxes.isCalculated)

  return (
    <Choose>
      <When condition={details && details.length > 0}>
        <TaxListItems />
      </When>
      <Otherwise>
        <TaxListItem
          currentTax={displayTaxes}
          isCalculated={isCalculated}
          key={0}
          taxLabel={label}
        />
      </Otherwise>
    </Choose>
  )
}

export default Taxes
